import { Tile, TileImage, TileOverlay } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import Image from 'components/LegacyImage'
import { PricingText } from 'components/PricingText'
import { usePageData } from '../PageDataProvider'
import { Cta } from './Cta'
import { BACKGROUND_IMAGES_CATEGORIES } from './backgroundImages'
import styles from './Hero.module.scss'

export const HeroTablet = () => {
  const { slug, category } = usePageData()
  const { t } = useTranslation('@mc/next')

  if (category === null) {
    reportError('Category not found in HeroTablet')
    return null
  }

  const WIDTH = 250
  const HEIGHT = WIDTH * 1.6

  return (
    <div className='d-none d-md-block d-lg-none'>
      <Tile
        className={`${styles.tileTablet} mc-mb-4`}
        role='group'
        aria-label={t('categories.categoryPage.hero.a11y.someInstructors', {
          categoryName: category?.name,
        })}
      >
        <TileOverlay color='0,0,0' />
        <div className='mc-mr-2 mc-mt-10'>
          <TileImage
            image={
              <Image
                src={BACKGROUND_IMAGES_CATEGORIES[slug].img1}
                alt=''
                width={WIDTH}
                height={HEIGHT}
              />
            }
            className='mc-corners--2'
          />
        </div>
        <TileImage
          image={
            <Image
              src={BACKGROUND_IMAGES_CATEGORIES[slug].img2}
              alt=''
              width={WIDTH}
              height={HEIGHT}
            />
          }
          className='mc-corners--2'
        />
      </Tile>

      <div
        className={`${styles.headline} ${styles.headlineMobileVariant} position-relative row justify-content-center mc-text--center`}
      >
        <h1 className='col-12 mc-text-d3 mc-text--brand mc-text--uppercase'>
          {t(`categories.categoryPage.hero.category.${slug}.headline`)}
        </h1>
        <h2 className='col-12 mc-text-h3 mc-my-5 mc-mb-6'>
          {t(`categories.categoryPage.hero.category.${slug}.subheadline`)}
        </h2>
        <div className='row justify-content-center mc-text--center align-items-start'>
          <div className='col-8'>
            <div className='mc-mb-4'>
              <Cta slug={slug} />
            </div>
          </div>
          <div className='col-9 mc-mt-1'>
            <p className='mc-text-small'>
              <PricingText
                translationKey='long'
                className='mc-opacity--hinted'
              />
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
